export default __webpack_public_path__ + "static/media/bin.65d263e8.svg";